import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';

const {fontRegular} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  liveBracketDialogText: {
    ...fontRegular,
    color: '#494949',
    fontSize: 13,
    lineHeight: 18,
    letterSpacing: -0.13,
    textAlign: 'center',
    paddingBottom: 32,
  },

  liveBracketDialogTimerContainer: {
    alignItems: 'center',
    borderRadius: 10,
  },

  liveBracketDialogTimerLabelStyling: {
    backgroundColor: 'transparent',
    borderRadius: 10,
  },
});
